import CONSTANTS from "core/constants";
import { format, fromUnixTime, isBefore } from "date-fns";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Typography } from "components/typography";
import { Slot } from "../../../../core/types";
import { SlotBookingInfo } from "../slotBookingInfo/slotBookingInfo";
import SlotDateTimePicker from "./slotDateTimePicker";

export const SlotDateAndStatusSection = ({
  slot,
  showBookingInfo,
}: {
  slot: Slot;
  showBookingInfo: boolean;
}) => {
  const { t } = useTranslation();
  const showDatePicker =
    !isBefore(fromUnixTime(slot.startsAt), new Date()) &&
    slot.status !== CONSTANTS.BOOKING_STATUS.CANCELED;

  return (
    <DateAndStatusSection>
      <DateTimeContainer>
        <Typography
          style={{ marginBottom: "6px" }}
          color="GRAY_DARK"
          variant="body-x-small"
          insensitive
        >
          {t("DATE")}
        </Typography>
        {showDatePicker ? (
          <SlotDateTimePicker slot={slot} />
        ) : (
          <Typography
            insensitive
            variant="body-small"
            style={{ paddingTop: "10px" }}
          >
            {format(
              fromUnixTime(slot.startsAt),
              CONSTANTS.DATE_FORMAT.YEAR_NAME_DATE_FORMAT,
            )}
          </Typography>
        )}
      </DateTimeContainer>
      {showBookingInfo && <SlotBookingInfo slot={slot} />}
    </DateAndStatusSection>
  );
};

const DateAndStatusSection = styled.div`
  display: grid;
  grid-template-columns: 424px 192px;
  padding: 0px 40px;
`;

const DateTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px 0 0;
  margin: 0 32 0 0;
`;
